import {
    useState,
    useEffect,
    useRef
} from "react";
import ImportClass from "./ImportClass";
import ClientService from "../../services/ClientService";
import {useParams} from "react-router-dom";
import ClientContext from "../../providers/CurrentClientProvider";
import AuthContext from "../../providers/AuthProvider";
import constants from '../../constants/constant'
import {Box, Button} from "@mui/material";

function ClientReportLibrary(props) {
    const isV3 = props?.visualVariant === 'v3';
    const { clientId } = useParams();
    const [source, setSource] = useState('bq');
    const auth_context = AuthContext.useAuth();
    const client_context = ClientContext.useClient(); // Access client context

    // Create a URL that uses the context value instead of just params
    const activeClientId = client_context.client?.Id || clientId;
    const url = `${constants.BACKEND_DOMAIN}/pdfreport/?user_id=${auth_context.user.id}&client_code=${activeClientId}&is_dev=1&source=${source}`;

    useEffect(() => {
        document.title = 'Retail ORBIT: Client Report Library';
    }, []);

    return (
        <Box
            className={isV3 ? 'v3-data-page v3-data-report-library-page v3-data-report-library-frame' : undefined}
            style={{position: 'relative', height: 'auto', minHeight: isV3 ? '72vh' : '100vh'}}
        >
            {/* Key changes whenever client or source changes, forcing a remount */}
            <iframe
                key={`${activeClientId}-${source}`}
                className={isV3 ? 'v3-data-report-library-iframe' : undefined}
                style={{position: 'absolute', height: '100%', width: '100%', border: 'none'}}
                src={url}
            />
        </Box>
    );
}

export default ClientReportLibrary